import {StopPlaySvc} from '../services/StopPlaySvc';
import {Observer} from '../services/ViewPortSvc';

export class BGVideo {
    url: string;
    isMobile: boolean = options.handHeld;
    onLoadedData: Function = this.onLoadedData || angular.noop;
    private videoEl: HTMLMediaElement;
    private stopPlaySvc: StopPlaySvc;

    constructor(private $element: ng.IAugmentedJQuery,
                private $rootScope: ng.IRootScopeService,
                private ViewPortSvc: Observer) {
        setTimeout(() => {
            if (!this.isMobile) {
                this.stopPlaySvc = new StopPlaySvc(
                    $rootScope,
                    ViewPortSvc,
                    $element,
                    canPlay => canPlay ? this.videoEl.play() : this.videoEl.pause()
                );
                this.videoEl = this.$element.find('video')[0] as HTMLMediaElement;
                this.videoEl.addEventListener('loadeddata', this.handlerVideoLoaded);
            }
            else {
                this.handlerVideoLoaded();
            }
        }, 0);
    }

    $onDestroy() {
        if (!this.isMobile) {
            this.stopPlaySvc.deactivate();
            this.videoEl.removeEventListener('loadeddata', this.handlerVideoLoaded);
        }
    }

    private handlerVideoLoaded = (ev?: Event) => {
        this.onLoadedData({event: ev});
        this.$element.addClass('video-done');
    }
}

angular.module('animatronApp.bgVideo', []).component('bgVideo', {
    bindings: {
        url: '<',
        onLoadedData: '&?'
    },
    transclude: true,
    controller: BGVideo,
    templateUrl: require('bg-video.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/bgVideo.ts